import { ID_LUXEMBOURG, ID_PORTUGAL, ID_UK, ID_USA, ID_BRASIL } from '~/utils/constants/idsCountries.js'

const AU_COUNTRIES = new Set([ID_LUXEMBOURG, ID_PORTUGAL, ID_UK, ID_BRASIL])
const AUX_COUNTRIES = new Set([ID_USA])

/**
 * Returns the French grammatical preposition to use before a country name.
 * - `'au'`  → masculine/singular countries (Portugal, UK, Brazil, Luxembourg)
 * - `'aux'` → plural countries (USA)
 * - `'en'`  → feminine/default (France and all others)
 * @param id - Internal country ID constant.
 */
export const getFrenchCountryPrep = (id?: number) => {
	if (!id) return 'en'

	if (AUX_COUNTRIES.has(id)) return 'aux'
	if (AU_COUNTRIES.has(id)) return 'au'

	return 'en'
}
